// utils
import _ from 'lodash';
// rules
import * as sameShiftConflict from './rules/_checkSameShiftConflict';
import * as professionalRestConflict from './rules/_checkProfessionalRestConflict';
import * as professionalScheduleConflict from './rules/_checkProfessionalScheduleConflict';
import * as scheduleOverlapConflict from './rules/_checkScheduleOverlapConflict';
import * as checkDailyVisitLimit from './rules/_checkDailyVisitLimit';

const rules = [
  sameShiftConflict,
  professionalRestConflict,
  professionalScheduleConflict,
  scheduleOverlapConflict,
  checkDailyVisitLimit
];

function _findErrors(schedulingEvents, padVisit = null) {
  const detailedErrors = [];
  const summaryErrors = [];

  // eslint-disable-next-line no-unused-vars
  for (const rule of rules) {
    const violatedRules = rule.check(schedulingEvents, padVisit);

    if (!_.isEmpty(violatedRules.detailedErrors)) {
      detailedErrors.push(...violatedRules.detailedErrors);
    }
    if (!_.isEmpty(violatedRules.summaryErrors)) {
      summaryErrors.push(...violatedRules.summaryErrors);
    }
  }

  return { detailedErrors, summaryErrors };
}

export { _findErrors };
